import React, { Component } from "react";
import "./Cards.css";
import OrderKomp from "./OrderKomp/OrderKomp";
import PayKomp from "./PayKomp/PayKomp";
import ScoreKomp from "./ScoreKomp/ScoreKomp";

export default class Cards extends Component {
  constructor(props) {
    super(props);
    this.state = {
      item: 0,
      SelectYear: null,
      ScoreCourse: null,
      ScoreSemester: null,
      SCORE: null,
      ORDERS: [],
      PAYMENT: [],
      SEMESTER: [],
    };
  }

  componentDidMount() {
    this.setState({
      PAYMENT: this.props.PAYMENT,
      ORDERS: this.props.ORDERS,
      SEMESTER: this.props.SEMESTER,
    });

    let scor = this.props.SCORE
      ? Object.keys(this.props.SCORE).map((key) => [
          Number(key),
          this.props.SCORE[key],
        ])
      : [];
    this.setState({
      SCORE: scor,
    });
  }

  change = (item) => {
    this.setState({ item });
  };

  render() {
    const { SCORE } = this.state;
    if (!SCORE) return null;
    const Orders = this.props.ORDERS;
    const Payment = this.props.PAYMENT;
    const Semester = this.props.SEMESTER;

    const scorelast = SCORE[SCORE.length - 1];

    let ScoreCard = null;
    let OrdersCard = [];
    let PaymentCard = [];

    if (Semester) {
      if (Semester.SEMESTER[0]) {
        if (Semester.SEMESTER[0].id_semester) {
          const semester = Semester.SEMESTER[0].id_semester;

          let ScoreCardList = SCORE.filter(
            (item) => item[1].id_semester == semester
          );

          // console.log(ScoreCardList)
          if (ScoreCardList[0]) {
            ScoreCard = ScoreCardList.map((item) => {
              return (
                <>
                  <div key={item[1].p34} className="dis_score_row">
                    <p>{item[1].p34}</p>
                    <p>{item[1].ball}</p>
                  </div>
                </>
              );
            });
          } else {
            ScoreCard = <h4>Нет данных об успеваемости на текущий семестр</h4>;
          }
        }
      }
    } else {
      let semester = scorelast[1].id_semester;
      let lastsemester = SCORE.filter(
        (item) => item[1].id_semester == semester
      );

      if (lastsemester[0]) {
        ScoreCard = lastsemester.map((item) => {
          return (
            <>
              <div key={item[1].p34} className="dis_score_row">
                <p>{item[1].p34}</p>
                <p>{item[1].ball}</p>
              </div>
            </>
          );
        });
      } else {
        ScoreCard = <h4>Нет данных...</h4>;
      }
    }

    if (Orders) {
      let Ubyl = [];
      OrdersCard.push(
        <>
          <h3>Прибытие</h3>
          <p>
            {" "}
            <span>{Orders[Orders.length - 1].pribil_prikaz}</span>
          </p>
          <p>
            {" "}
            {Orders[Orders.length - 1].pribil_numer}{" "}
            {Orders[Orders.length - 1].pribil_date}
          </p>
          <p> {Orders[Orders.length - 1].years}-учебный год</p>
          <p> {Orders[Orders.length - 1].id_rate}-курс</p>
          <p> {Orders[Orders.length - 1].spec}</p>

          {Ubyl}
          <label onClick={() => this.change(2)}>Подробнее...</label>
        </>
      );

      if (Orders[Orders.length - 1].ubil_prikaz) {
        Ubyl.push(
          <>
            <h4>Убытие</h4>
            <p>
              {" "}
              <span>{Orders[Orders.length - 1].ubil_prikaz}</span>{" "}
              {Orders[Orders.length - 1].ubil_num}{" "}
              {Orders[Orders.length - 1].ubil_date}
            </p>
          </>
        );
      }
    } else {
      OrdersCard.push(
        <>
          <p> нет данных... </p>
        </>
      );
    }

    if (Payment) {
      let RashodCard = [];
      PaymentCard.push(
        <>
          <h3>Приход</h3>
          <p>
            {" "}
            <span>{Payment[1][Payment[1].length - 1].uslugi2},</span>{" "}
            {Payment[1][Payment[1].length - 1].years2}-учебный год
          </p>
          <p>
            {" "}
            <span>{Payment[1][Payment[1].length - 1].prihod} сом</span>,{" "}
            {Payment[1][Payment[1].length - 1].vid_opl2}{" "}
          </p>
          <p>
            {" "}
            №{Payment[1][Payment[1].length - 1].orders2},{" "}
            {Payment[1][Payment[1].length - 1].dates2} г.{" "}
          </p>

          {RashodCard}
          <label onClick={() => this.change(3)}>Подробнее...</label>
        </>
      );
      if (Payment[2].length) {
        RashodCard.push(
          <>
            <h4>Расход</h4>
            <p>
              {" "}
              <span>{Payment[2][Payment[2].length - 1].uslugi3}</span>,{" "}
              {Payment[2][Payment[2].length - 1].years3}-учебный год
            </p>
            <p>
              {" "}
              <span>{Payment[2][Payment[2].length - 1].rashod} сом,</span>{" "}
              {Payment[2][Payment[2].length - 1].vid_opl3}{" "}
            </p>
            <p>
              {" "}
              №{Payment[2][Payment[2].length - 1].orders3},{" "}
              {Payment[2][Payment[2].length - 1].dates3} г.{" "}
            </p>
          </>
        );
      }
    } else {
      PaymentCard.push(
        <>
          <p> нет данных... </p>
        </>
      );
    }

    return (
      <div>
        <div className="cards_conatiner">
          <table className="Card_bgrnd">
            <tbody key="tbody">
              <tr>
                {this.props.SCORE && (
                  <td
                    style={{
                      // borderBottom: this.state.item == 1 ? "3px" : "none",
                      borderColor: this.state.item == 1 ? "#4967A3" : "#4967A3",
                      // borderBottomStyle: this.state.item == 1 ? "solid" : "none",
                    }}
                  >
                    <h2>Успеваемость</h2>
                    {ScoreCard}
                    <label onClick={() => this.change(1)}>Подробнее...</label>

                    {this.state.item == 1 && (
                      <div className="card_selected"></div>
                    )}
                  </td>
                )}
                {this.props.ORDERS && (
                  <td
                    style={{
                      // borderBottom: this.state.item == 2 ? "3px" : "none",
                      borderColor: this.state.item == 2 ? "#4967A3" : "#4967A3",
                      // borderBottomStyle: this.state.item == 2 ? "solid" : "none"
                    }}
                  >
                    <h2>Приказы</h2>
                    {OrdersCard}
                    {this.state.item == 2 && (
                      <div className="card_selected"></div>
                    )}
                  </td>
                )}
                {this.props.PAYMENT && (
                  <td
                    style={{
                      // borderBottom: this.state.item == 3 ? "3px" : "none",
                      borderColor: this.state.item == 3 ? "#4967A3" : "#4967A3",
                      // borderBottomStyle: this.state.item == 3 ? "solid" : "none"
                    }}
                  >
                    <h2>Оплаты</h2>
                    {PaymentCard}
                    {this.state.item == 3 && (
                      <div className="card_selected"></div>
                    )}
                  </td>
                )}
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          {this.state.item == 1 && (
            <div className="Score_container" id="score">
              <ScoreKomp SCORE={this.props.SCORE} YEAR={this.props.YEAR} />
            </div>
          )}
          {this.state.item == 2 && (
            <div id="orders">
              <OrderKomp ORDERS={this.props.ORDERS} />
            </div>
          )}
          {this.state.item == 3 && (
            <div id="payment">
              <PayKomp PAYMENT={this.props.PAYMENT} />
            </div>
          )}
        </div>
      </div>
    );
  }
}
